function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level1_svg__b",
  x1: 57.02,
  y1: 91.8,
  x2: 15.89,
  y2: -14.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level1_svg__a",
  x1: 26.33,
  y1: -12.37,
  x2: 36.87,
  y2: 45.23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level1_svg__c",
  x1: 53.89,
  y1: 76.28,
  x2: 30.8,
  y2: 25.83,
  xlinkHref: "#3-level1_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35 0a35 35 0 1035 35A35 35 0 0035 0z",
  fill: "url(#3-level1_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 12.35A22.65 22.65 0 1057.65 35 22.65 22.65 0 0035 12.35z",
  fill: "url(#3-level1_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 17a18 18 0 1018 18 18 18 0 00-18-18z",
  fill: "url(#3-level1_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.68 39.83v-6.95h-2.55v-1.73a2.78 2.78 0 002.91-2h2.23v10.68z",
  fill: "#fff"
}));

function Svg3Level1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70 70"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNzAgNzAiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjU3LjAyIiB5MT0iOTEuOCIgeDI9IjE1Ljg5IiB5Mj0iLTE0LjMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMyM2MzODYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM4MGU4YmIiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjI2LjMzIiB5MT0iLTEyLjM3IiB4Mj0iMzYuODciIHkyPSI0NS4yMyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzAwNzc2MyIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzIzYzM4NiIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJjIiB4MT0iNTMuODkiIHkxPSI3Ni4yOCIgeDI9IjMwLjgiIHkyPSIyNS44MyIgeGxpbms6aHJlZj0iI2EiLz48L2RlZnM+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48cGF0aCBkPSJNMzUgMGEzNSAzNSAwIDEwMzUgMzVBMzUgMzUgMCAwMDM1IDB6IiBmaWxsPSJ1cmwoI2IpIi8+PHBhdGggZD0iTTM1IDEyLjM1QTIyLjY1IDIyLjY1IDAgMTA1Ny42NSAzNSAyMi42NSAyMi42NSAwIDAwMzUgMTIuMzV6IiBmaWxsPSJ1cmwoI2EpIi8+PHBhdGggZD0iTTM1IDE3YTE4IDE4IDAgMTAxOCAxOCAxOCAxOCAwIDAwLTE4LTE4eiIgZmlsbD0idXJsKCNjKSIvPjxwYXRoIGQ9Ik0zNC42OCAzOS44M3YtNi45NWgtMi41NXYtMS43M2EyLjc4IDIuNzggMCAwMDIuOTEtMmgyLjIzdjEwLjY4eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=";
export { Svg3Level1 as ReactComponent };